import React, { useState } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import BrandMark from "./BrandMark";
import "../css/footer.scss";

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleNewsletter = (event) => {
    event.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setMessage("Enter a valid email address.");
      return;
    }
    setMessage(
      `Newsletter registration is not available yet. Contact ${siteConfig.contact.email} for updates.`,
    );
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="site-footer__newsletter"
        aria-labelledby="newsletter-title"
      >
        <div>
          <p>LET’S KEEP IN TOUCH</p>
          <h2 id="newsletter-title">
            A little inspiration, from our corner to yours.
          </h2>
        </div>
        <form onSubmit={handleNewsletter} noValidate>
          <label htmlFor="footer-email">Email address</label>
          <div>
            <input
              id="footer-email"
              type="email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setMessage("");
              }}
              placeholder="Your email address"
              aria-describedby="newsletter-message"
            />
            <button type="submit">Keep me posted</button>
          </div>
          <p
            id="newsletter-message"
            className="site-footer__form-message"
            aria-live="polite"
          >
            {message}
          </p>
        </form>
      </section>

      <div className="site-footer__body">
        <Link
          className="site-footer__wordmark"
          to="/"
          onClick={toTop}
          aria-label={`${siteConfig.brandName} home`}
        >
          <BrandMark />
        </Link>

        <div className="site-footer__columns">
          <nav aria-label="Customer information">
            <h3>INFORMATION</h3>
            <Link to="/shipping" onClick={toTop}>
              SHIPPING
            </Link>
            <Link to="/returns" onClick={toTop}>
              RETURNS
            </Link>
            <Link to="/contact" onClick={toTop}>
              CONTACT
            </Link>
            <Link to="/privacy" onClick={toTop}>
              PRIVACY
            </Link>
            <Link to="/terms" onClick={toTop}>
              TERMS OF USE
            </Link>
          </nav>
          <nav aria-label="Company information">
            <h3>THE COMPANY</h3>
            <Link to="/about" onClick={toTop}>
              OUR STORY
            </Link>
            <Link to="/about#factory">OUR APPROACH</Link>
            <Link to="/shop" onClick={toTop}>
              ALL PRODUCTS
            </Link>
            <Link to="/contact" onClick={toTop}>
              STOCKISTS
            </Link>
          </nav>
          <nav aria-label="Additional information">
            <h3>MORE</h3>
            <Link to="/faqs" onClick={toTop}>
              FAQS
            </Link>
            <Link to="/cookies" onClick={toTop}>
              COOKIE POLICY
            </Link>
            <a href={siteConfig.website}>OUR WEBSITE</a>
          </nav>
          <div className="site-footer__contact">
            <h3>Connect</h3>
            <a href={`mailto:${siteConfig.contact?.email}`}>
              {siteConfig.contact?.email}
            </a>
            <p>{siteConfig.companyName}</p>
            <p>{siteConfig.contact?.address}</p>
          </div>
        </div>
      </div>

      <div className="site-footer__legal">
        <span>
          {siteConfig.brandName} — {siteConfig.origin}
        </span>
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
      </div>
    </footer>
  );
}

export default Footer;
